import { Box, CircularProgress } from '@mui/material';

import { styles } from './styles';

// interface SpinnerProps {
//   visible: boolean;
// }
export const Spinner = () => {
  // const { visible = false } = props;

  return (
    <Box sx={styles.container}>
      <CircularProgress disableShrink />
    </Box>
  );
};
